import React, { useState, useContext, useEffect } from "react";
import "../Styles.css";
import { updateProfile, deleteCertificate } from "../../../actions/users";
import "./doctorProfile.css";
import "../../../ui-styles/list/EditProfileImage.css";
import "../../../ui-styles/profile/VrtclProfile.css";
import "../../../ui-styles/profile/ProfileDetails.css";
import "../../../ui-styles/profile/SlideProfileDetails.css";
import "../../../ui-styles/prescription/prescriptionAdd.css";
import { Storage } from "aws-amplify";
import { OffLineAPI } from "../../../offline-auth/api";
import Loader from "../../../lib/ui/loader/Loader";
import { dateFormat } from "../../../lib/functions";
import { LangCtx, PayLoadCtx } from "../../../lib/context";
import EditDoctorProfile from "./EditDoctorProfile";
import { toast } from "react-toastify";
import { isValidPhoneNumber } from "react-phone-number-input";
import CertificateFileView from "./certificateFileView";
import { validateEmail, validateLetters, validateDcotorDob } from "../../../lib/validation";
import { Auth } from "aws-amplify";
import ProfileImage from "../../common/profileImage";
import { addrLangObj } from "../../../locale/address";
import { parsePhoneNumber } from "react-phone-number-input";
import { Dialog, DialogActions, DialogContent, DialogTitle, Tab, Tabs } from "@material-ui/core";
import MedicalCertificate from "./MedicalCertificate";
import ProvisionalCertificate from "./ProvisionalCertificate";
import { MdDelete } from "react-icons/md";
import { BiCommentDetail } from "react-icons/bi";
import { getDegree, getDepartmentList } from "../../../actions/configuration";

const DoctorProfile = (props) => {
    const [editProfile, setEditProfile] = useState(false);
    const { l } = useContext(LangCtx);
    const al = addrLangObj[l.locale];
    const { payload, getPayLoad } = useContext(PayLoadCtx);
    const [loading, setLoading] = useState(false);
    const [errorMsg, setErrorMsg] = useState(null);
    const [error, setError] = useState({});
    const [uploadView, setUploadView] = useState(null)
    const [holdUploadBody, setHoldUploadBody] = useState({});
    const [editedDoctor, setEditedDoctor] = useState({});
    const [value, setValue] = useState(0);
    const [openDialog, setOpenDialog] = useState(false);
    const [documents, setDocuments] = useState({
        medicaldocuments: { title: "Medical Certifications", data: [] },
        provisionaldocuments: { title: "Provisional Certificates", data: [] },
    });
    const acceptedTypes = ["doc", "docx", "pdf", "xls", "xlsx", "ppt", "pptx"]
    const [specializations, setSpecializations] = useState([{
        label: 'Select specialization',
        name: ''
    }]);
    const [departments, setDepartments] = useState([]);
    const [degrees, setDegrees] = useState([]);
    const minDate = new Date();
    minDate.setMonth(minDate.getMonth() + 1);
    minDate.setDate(minDate.getDate() + 1);
    minDate.setHours(0, 0, 0, 0);

    const [formData, setFormData] = useState({
        license: "",
        licenseNo: "",
        country: "",
        expirationDate: minDate,
        issueDate: new Date(),
    })
    const [provisionalFormData, setProvisionalFormData] = useState({
        degree: "",
        speciality: "",
        department: "",
        expirationDate: new Date(),
    });
    const [department, setDepartment] = useState({ value: '', id: '' });
    const [certificateData, setCertificateData] = useState({})
    let medicaldata
    let provisionaldata

    const handleOpenDialog = () => {
        setOpenDialog(true);
        setFormData({
            license: "",
        licenseNo: "",
        country: "",
        expirationDate: minDate,
        issueDate: ""
        })
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
        setFormData({
            license: certificateData.license ? certificateData.license : "",
            licenseNo: certificateData.licenseNo ? certificateData.licenseNo : "",
            country: certificateData.country ? certificateData.country : "",
            expirationDate: minDate,
            issueDate: new Date().valueOf(),
        })
        setProvisionalFormData({
            degree: "",
            speciality: "",
            department: "",
            expirationDate: new Date()
        })
    };

    const handleSaveDialog = () => {
        setOpenDialog(false);
        getPayLoad();
    };

    const handleFileView = (data) => {
        setUploadView(data)
    }

    const handleCloseFile = () => {
        setUploadView(null)
    }

    const handleTabChange = (event, newValue) => {
        setValue(newValue);
    };

    useEffect(() => {
        medicaldata = payload.medicaldocuments?.length > 0 ? payload.medicaldocuments : payload.licenses
        provisionaldata = payload.provisionaldocuments?.length > 0 ? payload.provisionaldocuments : {}
        const medicaldataCerti = medicaldata[medicaldata.length - 1]
        console.log("medicaldataCerti::", medicaldataCerti)
        setCertificateData(medicaldataCerti)
        setDocuments({
            medicaldocuments: {
                title: "Medical Certifications",
                data: payload.medicaldocuments || [],
            },
            provisionaldocuments: {
                title: "Provisional Certificates",
                data: payload.provisionaldocuments || [],
            },
        });
        setFormData({
            license: medicaldataCerti.license ? medicaldataCerti.license : "",
            licenseNo: medicaldataCerti.licenseNo ? medicaldataCerti.licenseNo : "",
            country: medicaldataCerti.country ? medicaldataCerti.country : "",
            expirationDate: minDate,
            issueDate: new Date().valueOf(),
        });
        handleData()
    }, [payload]);

    const handleData = () => {
        let departmentQuery = payload.clinicId ? `?clinicId=${payload.clinicId}&type=all` : '?type=all';
        let degreeQuery = payload.clinicId ? `?clinicId=${payload.clinicId}` : '';
        const departmentPromise = getDepartmentList(departmentQuery);
        const degreePromise = getDegree(degreeQuery);
        Promise.all([departmentPromise, degreePromise])
            .then(([departmentRes, degreeRes]) => {
                if (departmentRes.status) {
                    let departmentList = [...departmentRes.data];
                    departmentList.unshift({
                        name: '',
                        label: 'Select Department'
                    });
                    setDepartments(departmentList);
                } else {
                    console.error("Failed to fetch departments:", departmentRes);
                }
                if (degreeRes.status) {
                    let degreeList = [...degreeRes.data];
                    degreeList.unshift({
                        name: '',
                        label: 'Select Degree'
                    });
                    setDegrees(degreeList);
                } else {
                    console.error("Failed to fetch degrees:", degreeRes);
                }
            })
            .catch((error) => {
                // Handle any errors in either API call
                toast.error(error?.response?.data?.error || "An error occurred", {
                    position: toast.POSITION.TOP_RIGHT
                });
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const handleEditProfle = () => {
        setEditProfile((prevState) => {
            if (!prevState) {
                setEditedDoctor({
                    ...payload,
                    phone: payload?.countryCode ? `+${payload?.countryCode}${payload?.phone}` : payload?.phone,
                });
            }
            return !prevState;
        });
        setError({});
    };

    const handleChange = (name, value) => {
        let _editedDoctor = { ...editedDoctor };
        _editedDoctor = {
            ..._editedDoctor,
            [name]: value,
        };
        setEditedDoctor(_editedDoctor);
    };
    console.log("this is for chunk issue", handleChange)
    const validateForm = () => {
        let _error = {};
        let returnValue = true;

        if (editedDoctor.firstName === "" || editedDoctor.firstName == null) {
            _error["firstName"] = l.pls_ent_fName;
            returnValue = false;
        } else if (!validateLetters(editedDoctor.firstName)) {
            _error["firstName"] = l.pls_ent_letters_fName;
            returnValue = false;
        }
        if (editedDoctor.lastName === "" || editedDoctor.lastName == null) {
            _error["lastName"] = l.pls_ent_lName;
            returnValue = false;
        } else if (!validateLetters(editedDoctor.lastName)) {
            _error["lastName"] = l.pls_ent_letters_lName;
            returnValue = false;
        }
        if (editedDoctor.gender === "" || editedDoctor.gender == null) {
            _error["gender"] = l.pls_sel_gender;
            returnValue = false;
        }
        if (editedDoctor.dob === "" || editedDoctor.dob == null) {
            _error["dob"] = l.pls_sel_dob;
            returnValue = false;
        } else if (!validateDcotorDob(editedDoctor.dob)) {
            _error["dob"] = l.pls_check_doc_dob;
            returnValue = false;
        }
        if (editedDoctor.email === "" || editedDoctor.email == null) {
            _error["email"] = l.pls_check_email;
            returnValue = false;
        } else if (!validateEmail(editedDoctor.email)) {
            _error["email"] = l.pls_check_email;
            returnValue = false;
        }
        if (editedDoctor.phone && !isValidPhoneNumber(editedDoctor.phone)) {
            _error["phone"] = l.pls_check_ph_number;
            setErrorMsg(l.pls_check_ph_number);
            returnValue = false;
        }
        setError(_error);
        console.log("error in doctor", _error);
        return returnValue;
    };

    const handlePhoneChange = (value) => {
        setEditedDoctor((prevState) => {
            return { ...prevState, phone: value };
        });

        if (value && (value !== "" || value !== undefined)) {
            if (!isValidPhoneNumber(value)) {
                setError((prevState) => ({
                    ...prevState,
                    phone: "Please Enter Valid Phone Number",
                }));
                setErrorMsg(l.pls_check_ph_number);
            } else {
                setError((prev) => ({
                    ...prev,
                    phone: "",
                }));
                setErrorMsg("");
            }
        } else {
            setError((prevState) => ({
                ...prevState,
                phone: "Please Enter Phone Number",
            }));
            setErrorMsg("");
        }
    };

    const handleAlternatePhoneChange = (value) => {
        setEditedDoctor((prevState) => {
            return { ...prevState, alternatePhone: value };
        });

        if (value && (value !== "" || value !== undefined)) {
            if (!isValidPhoneNumber(value)) {
                setError((prev) => ({
                    ...prev,
                    alternatePhone: l.pls_check_ph_number,
                }));
                setErrorMsg(l.pls_check_ph_number);
            } else {
                setError((prev) => ({
                    ...prev,
                    alternatePhone: "",
                }));
                setErrorMsg("");
            }
        } else {
            setError((prev) => ({
                ...prev,
                alternatePhone: "",
            }));
            setErrorMsg("");
        }
    };

    const deleteOnlineOrOfflineFile = async (url, uploadkey) => {
        const body = {
            url: url,
            uploadkey: uploadkey,
        };
        try {
            if (process.env.REACT_APP_isOffline === "true") {
                await OffLineAPI.uploadDelete("api", "/deletefile", { body });
            } else {
                await Storage.remove(uploadkey);
            }
        } catch (err) {
            console.log("error while delete file =====", err);
        }
    };

    const handleDeleteCertificate = async (id, key, url, type) => {
        setLoading(true);
        await deleteOnlineOrOfflineFile(url, key);
        let body = {
            clinicId: payload.clinicId,
            documentType: type,
        };
        deleteCertificate(id, body)
            .then((res) => {
                setLoading(false);
                if (res.status) {
                    setError({});
                    getPayLoad()
                    toast.success("File removed successfully", {
                        position: toast.POSITION.TOP_RIGHT,
                    });
                }
            })
            .catch((err) => {
                setLoading(false);
                toast.error(err.errorMessage, {
                    position: toast.POSITION.TOP_RIGHT,
                });
            });
    };

    const handleUpdateDoctor = (e) => {
        e.preventDefault();
        try {
            if (validateForm()) {
                // const phoneNumber = parsePhoneNumber(editedDoctor?.phone);
                if (!editedDoctor?.phone || editedDoctor.phone.trim() === "") {
                    setErrorMsg("Please enter the phone number.");
                    window.scrollTo({ top: 0, behavior: "smooth" });
                    return;
                }

                const phoneNumber = parsePhoneNumber(editedDoctor?.phone);
                if (!phoneNumber) {
                    setErrorMsg("Please enter a valid phone number.");
                    window.scrollTo({ top: 0, behavior: "smooth" });
                    return;
                }
                const countrycode = phoneNumber?.countryCallingCode.toString();
                const number = phoneNumber.nationalNumber;
                setLoading(true);
                let body = {
                    consultRole: "doctor",
                    firstName: editedDoctor.firstName.trim(),
                    lastName: editedDoctor.lastName.trim(),
                    email: editedDoctor.email.trim(),
                    countryCode: countrycode,
                    phone: number ? number : "",
                    alternatePhone: editedDoctor?.alternatePhone ? editedDoctor?.alternatePhone : "",
                    dob: editedDoctor.dob,
                    address: editedDoctor.address ? editedDoctor.address : "",
                    country: editedDoctor.country ? editedDoctor.country : "",
                    stateName: editedDoctor.stateName ? editedDoctor.stateName : "",
                    city: editedDoctor.city ? editedDoctor.city : "",
                    pincode: editedDoctor.pincode.trim() ? editedDoctor.pincode.trim() : "",
                    summary: editedDoctor.summary,
                };

                if (process.env.REACT_APP_isOffline === "true") {
                    updateProfile(body)
                        .then((res) => {
                            setLoading(false);
                            if (res.status) {
                                //loadDoctor();
                                toast.success(l.upd_succ, {
                                    position: toast.POSITION.TOP_RIGHT,
                                });
                                setEditProfile((prevState) => !prevState);
                                getPayLoad();
                            }
                        })
                        .catch((err) => {
                            console.log("error in update doctor=====", err);
                            setLoading(false);
                            let msg = err?.response?.data?.error
                                ? err.response.data.error
                                : err.errorMessage
                                    ? err.errorMessage
                                    : l.unable_upd_doc;
                            toast.error(msg, {
                                position: toast.POSITION.TOP_RIGHT,
                            });

                            setErrorMsg(msg);
                        });
                } else {
                    Auth.currentAuthenticatedUser().then((user) => {
                        Auth.updateUserAttributes(user, {
                            "custom:fname": editedDoctor.firstName.trim(),
                            // 'custom:lname': editedDoctor.lastName.trim(),
                            // 'custom:email': editedDoctor.email.trim(),
                            // 'custom:dob': editedDoctor.dob.toString(),
                            // 'custom:Country': editedDoctor.country,
                            // 'custom:State': editedDoctor.stateName,
                            // 'custom:District': editedDoctor.city
                        }).then((result) => {
                            updateProfile(body)
                                .then((res) => {
                                    setLoading(false);
                                    if (res.status) {
                                        //loadDoctor();
                                        toast.success(l.upd_succ, {
                                            position: toast.POSITION.TOP_RIGHT,
                                        });
                                        // setDoctor(null);
                                        setEditProfile((prevState) => !prevState);
                                        getPayLoad();
                                        //  handleEditProfle();
                                    }
                                })
                                .catch((err) => {
                                    console.log("error in update doctor=====", err);
                                    setLoading(false);
                                    let msg = err?.response?.data?.error
                                        ? err.response.data.error
                                        : err.errorMessage
                                            ? err.errorMessage
                                            : l.unable_upd_doc;
                                    toast.error(msg, {
                                        position: toast.POSITION.TOP_RIGHT,
                                    });
                                    setErrorMsg(msg);
                                });
                        });
                    });
                }
            } else {
                if (errorMsg != null) {
                    window.scrollTo({
                        top: 0,
                        behavior: "smooth",
                    });
                }
            }
        } catch (err) {
            setLoading(false);
            toast.error(err.errorMessage, {
                position: toast.POSITION.TOP_RIGHT,
            });
            setErrorMsg(l.went_worng_pls_try_again);
        }
    };

    console.log("eeee", error);

    return loading ? (
        <Loader />
    ) : payload != null ? (
        <div className="baseContainer">
            <div className="myProfleContainer">
                <div className="vrtclProfileCol">
                    <ProfileImage userDetails={payload} userRole={"D"} certfyStyle={"ProfileLayout"} />
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            width: "100%",
                            height: "90vh",
                        }}
                        onMouseEnter={(e) => (e.currentTarget.style.overflowY = "auto")}
                        onMouseLeave={(e) => (e.currentTarget.style.overflowY = "hidden")}
                    >
                        <div className="profileDtlsCol">
                            <div className="profleHdngRow">
                                <span className="profileSHdgn">{l.contact_details}</span>
                                <div className="proflieEdit" onClick={handleEditProfle}>
                                    <img src="/images/icons/edit-outline.png" className="inlineIcon invertPrimary" alt="icon" />
                                    <small className="inlinetxt">{l.edit}</small>
                                </div>
                            </div>

                            <ul className="profileGroupCol">
                                <li className="profileListItem">
                                    <span className="profileInfoTxt">{l.label_dob}</span>
                                    <span className="profileInfoTxt dark">{payload.dob ? dateFormat(payload.dob) : ""}</span>
                                </li>
                                <li className="profileListItem">
                                    <span className="profileInfoTxt">{l.label_phone_no}</span>
                                    <span className="profileInfoTxt dark">
                                        {payload.phone
                                            ? payload?.countryCode
                                                ? `+${payload?.countryCode}${payload?.phone}`
                                                : payload?.phone
                                            : "--"}
                                    </span>
                                </li>
                                <li className="profileListItem">
                                    <span className="profileInfoTxt">{"Alternate " + l.label_phone_no}</span>
                                    <span className="profileInfoTxt dark">{payload.alternatePhone ? payload.alternatePhone : ""}</span>
                                </li>
                                <li className="profileListItem">
                                    <span className="profileInfoTxt">{l.label_email}</span>
                                    <span className="profileInfoTxt dark">{payload.email ? payload.email : ""}</span>
                                </li>
                                {/* <li className="profileListItem">
                                    <span className="profileInfoTxt">{l.label_qual}</span>
                                    <span className="profileInfoTxt dark">{payload.qualification ? payload.qualification : ''}</span>
                                </li>
                                <li className="profileListItem">
                                    <span className="profileInfoTxt">{l.label_dept}</span>
                                    <span className="profileInfoTxt dark">{payload.department ? payload.department : ''}</span>
                                </li>
                                <li className="profileListItem">
                                    <span className="profileInfoTxt">{l.label_spec}</span>
                                    <span className="profileInfoTxt dark">{payload.speciality ? l[payload.speciality] : ''}</span>
                                </li> */}
                                <li className="profileListItem">
                                    <span className="profileInfoTxt">{l.label_service_std}</span>
                                    <span className="profileInfoTxt dark">
                                        {payload.serviceStartDate ? dateFormat(payload.serviceStartDate) : ""}
                                    </span>
                                </li>
                                <li className="profileListItem">
                                    <span className="profileInfoTxt">{l.label_address}</span>
                                    <span className="profileInfoTxt dark">{payload.address ? payload.address : ""}</span>
                                </li>
                                {/* <li className="profileListItem">
                                    <span className="profileInfoTxt">{l.label_division}</span>
                                    <span className="profileInfoTxt dark">{payload.division ? payload.division : ''}</span>
                                </li> */}
                                <li className="profileListItem">
                                    <span className="profileInfoTxt">{l.label_city}</span>
                                    <span className="profileInfoTxt dark">{payload.city ? al[payload.city] : ""}</span>
                                </li>
                                <li className="profileListItem">
                                    <span className="profileInfoTxt">{l.label_state}</span>
                                    <span className="profileInfoTxt dark">{payload.stateName ? al[payload.stateName] : ""}</span>
                                </li>
                                <li className="profileListItem">
                                    <span className="profileInfoTxt">{l.label_pin}</span>
                                    <span className="profileInfoTxt dark">{payload.pincode ? payload.pincode : ""}</span>
                                </li>
                            </ul>
                            {payload.medicaldocuments.length > 0 && <div className="profleHdngRow">
                                <span className="profileSHdgn">{l.med_det}</span>
                            </div>}
                            {payload.medicaldocuments.length > 0 && <div className="prescTableWrapper" style={{overflowX:'auto',whiteSpace:"nowrap"}}>
                                <table className="prescTable TableMinWidth">
                                    <thead>
                                        <tr>
                                            <th>{l.si_no}</th>
                                            <th>{l.med_lic}</th>
                                            <th>{l.lic_no}</th>
                                            <th>{l.exp_date}</th>
                                            <th>{l.country}</th>
                                            <th>{l.status}</th>
                                            <th>{l.actions}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {console.log("payload", payload)}
                                        {payload.medicaldocuments ? (
                                            payload.medicaldocuments.map((license, i) => (
                                                <tr className="txtCenter" key={license.licenseNo}>
                                                    <td>{i + 1}</td>
                                                    <td>{license.license}</td>
                                                    <td>{license.licenseNo}</td>
                                                    <td>{dateFormat(license.expirationDate)}</td>
                                                    <td>{license.country}</td>
                                                    <td>{<span
                                                        className="pdngRSM smallText"
                                                        style={{
                                                            fontSize: "12px",
                                                            color: license.status === "rejected" ? "#FD8D8D" : "#4CAF50",
                                                        }}
                                                    >
                                                        {license.status.charAt(0).toUpperCase() +

                                                            license.status.slice(1).toLowerCase()}
                                                    </span>}</td>
                                                    <td style={{ display: "flex", justifyContent: "space-between", cursor: "pointer" ,flexDirection:'column',gap:'10px'}}>
                                                        <span style={{ color: "#24a4c4", textDecoration: "underline" ,fontSize:'12px'}} onClick={() => handleFileView(license)}>View</span>
                                                        { console.log("type2",license.title)}
                                                        {license.status !== "approved" && (
                                                            <span style={{ color: "#24a4c4", textDecoration: "underline",fontSize:'12px' }} onClick={() =>
                                                                handleDeleteCertificate(
                                                                    license._id,
                                                                    license.key,
                                                                    license.url,
                                                                    license.title === "Medical Certifications"
                                                                        ? "provisionaldocuments"
                                                                        : "medicaldocuments"
                                                                )
                                                            }>Delete
                                                            </span>
                                                        )}</td>
                                                </tr>
                                            ))
                                        ) : (
                                            <div className="profielDtlItem">
                                                {" "}
                                                <span className="profileDtlTxt">No licenses</span>
                                            </div>
                                        )}
                                    </tbody>
                                </table>
                            </div>}
                            {payload.provisionaldocuments.length > 0 && <div className="profleHdngRow mrgTop24">
                                <span className="profileSHdgn">{l.prov_det}</span>
                            </div>}
                            {payload.provisionaldocuments.length > 0 && <div className="prescTableWrapper" style={{overflowX:'auto',whiteSpace:"nowrap"}}>
                                <table className="prescTable TableMinWidth">
                                    <thead>
                                        <tr>
                                            <th>{l.si_no}</th>
                                            <th>{l.med_lic}</th>
                                            <th>Degree Name</th>
                                            <th>Year of Passing</th>
                                            <th>Specialist</th>
                                            <th>{l.status}</th>
                                            <th>{l.actions}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {console.log("payload", payload.provisionaldocuments)}
                                        {payload.provisionaldocuments ? (
                                            payload.provisionaldocuments.map((provesional, i) => (
                                                <tr className="txtCenter" key={provesional.licenseNo}>
                                                    <td>{i + 1}</td>
                                                    <td>{provesional.licenseAuthority}</td>
                                                    <td>{provesional.degree}</td>
                                                    <td>{provesional.yearOfPassing}</td>
                                                    <td>{provesional.speciality}</td>
                                                    <td>{<span
                                                        className="pdngRSM smallText"
                                                        style={{
                                                            fontSize: "12px",
                                                            color: provesional.status === "rejected" ? "#FD8D8D" : "#4CAF50",
                                                        }}
                                                    >
                                                        {provesional.status.charAt(0).toUpperCase() +

                                                            provesional.status.slice(1).toLowerCase()}
                                                    </span>}</td>
                                                    <td style={{ display: "flex", justifyContent: "space-between", cursor: "pointer",flexDirection:'column',gap:'10px' }}>
                                                        <span style={{ color: "#24a4c4", textDecoration: "underline" ,fontSize:'12px'}} onClick={() => handleFileView(provesional)}>View</span>
                                                       { console.log("type",provesional.title)}
                                                        {provesional.status !== "approved" && (
                                                            <span style={{ color: "#24a4c4", textDecoration: "underline" ,fontSize:'12px'}} onClick={() =>
                                                                handleDeleteCertificate(
                                                                    provesional._id,
                                                                    provesional.key,
                                                                    provesional.url,
                                                                    provesional.title === "provisionaldocuments"
                                                                        ? "medicaldocuments"
                                                                        : "provisionaldocuments"
                                                                )
                                                            }>Delete
                                                            </span>
                                                        )}</td>
                                                </tr>
                                            ))
                                        ) : (
                                            <div className="profielDtlItem">
                                                {" "}
                                                <span className="profileDtlTxt">No licenses</span>
                                            </div>
                                        )}
                                    </tbody>
                                </table>
                            </div>}
                        </div>
                        <div
                            className="pdngSM alignEnd childRight"
                            style={{
                                display: "flex",
                            }}
                        >
                            <button
                                className="alignCenter justifyCenter brdrRadius cursorPointer"
                                onClick={handleOpenDialog}
                                style={{
                                    color: "#23A4C4",
                                    border: "2px solid #23A4C4",
                                    padding: "8px",
                                    backgroundColor: "transparent",
                                }}
                            >
                                Add Certificate +
                            </button>
                        </div>
                        {/* <div className="flexCol">
                            {Object.values(documents).map((section, sectionIndex) => (
                                <div
                                    className="flexCol mrgBtm8 brdrRadius"
                                    style={{ border: "1px solid #D4D4D4", padding: "10px" }}
                                    key={sectionIndex}
                                 >
                                    <span style={{ fontSize: "16px", fontWeight: "500", paddingBottom: "12px" }}>{section.title}</span>
                                    {section.data.map((certificate) => (
                                        <div
                                            key={certificate._id}
                                            className="flexRow "
                                            style={{
                                                backgroundColor: "#fff",
                                                padding: "14px",
                                                borderRadius: "11px",
                                                marginBottom: "10px",
                                            }}
                                        >
                                            <div className="flexAutoRow" style={{ height: "90px", width: "90px", paddingRight: "8px" }}>
                                                <img
                                                    src={
                                                        certificate?.fileType?.startsWith("image") ? certificate.url :
                                                            acceptedTypes?.includes(certificate?.key?.split(".").pop())
                                                                ? `/images/file-icons/${certificate.key ? certificate.key.split(".").pop() : "blank"}-file.png`
                                                                : `/images/file-icons/blank-file.png`

                                                    }
                                                    style={{
                                                        ...(
                                                            certificate?.fileType?.startsWith("image")
                                                                ? { height: "100%", width: "100%", objectFit: "contain" }
                                                                : { height: "80%", width: "80%", objectFit: "contain" }
                                                        ),
                                                        cursor: "pointer",
                                                    }}
                                                    alt="Certification"
                                                    onClick={() => handleFileView(certificate)}
                                                />
                                            </div>
                                            <div className="flexMinWidthCol ">
                                                <div className="flexRow">
                                                    <span
                                                        className="ellipsisTxt"
                                                        style={{ fontSize: "14px", fontWeight: "500", lineHeight: 1.4 }}
                                                    >
                                                        {section.title === "Medical Certifications"
                                                            ? certificate.license
                                                            : certificate.department}
                                                    </span>

                                                    <span
                                                        className="pdngRSM smallText"
                                                        style={{
                                                            fontSize: "12px",
                                                            color: certificate.status === "rejected" ? "#FD8D8D" : "#4CAF50",
                                                        }}
                                                    >
                                                        {certificate.status.charAt(0).toUpperCase() +
                                                            certificate.status.slice(1).toLowerCase()}
                                                    </span>
                                                    {certificate.status !== "approved" && (
                                                        <span style={{ display: "flex", alignItems: "center" }}>
                                                            <MdDelete
                                                                style={{ color: "#A4A4A4", fontSize: "18px", cursor: "pointer" }}
                                                                onClick={() =>
                                                                    handleDeleteCertificate(
                                                                        certificate._id,
                                                                        certificate.key,
                                                                        certificate.url,
                                                                        section.title === "Medical Certifications"
                                                                            ? "medicaldocuments"
                                                                            : "provisionaldocuments"
                                                                    )
                                                                }
                                                            />
                                                        </span>
                                                    )}

                                                </div>
                                                <div className="flexRow" style={{ justifyContent: "space-between" }}>
                                                    <div className="flexRow" style={{ justifyContent: "space-between" }}>
                                                        {section.title === "Medical Certifications" ? (
                                                            <div className="flexAutoCol pdngRSM">
                                                                <span className="smallText"> License No.: {certificate.licenseNo}</span>
                                                                <span className="smallText"> Issue Date: {new Date(certificate.issuedDate).toLocaleDateString("en-US", {
                                                                    year: "numeric",
                                                                    month: "long",
                                                                    day: "numeric",
                                                                })} </span>

                                                                <span className="smallText">
                                                                    Expiry Date:{" "}
                                                                    {new Date(certificate.expirationDate).toLocaleDateString("en-US", {
                                                                        year: "numeric",
                                                                        month: "long",
                                                                        day: "numeric",
                                                                    })}
                                                                </span>
                                                                <span className="smallText"> {certificate.country}</span>
                                                                {(() => {
                                                                    if (certificate.status === "approved") {
                                                                        const expiryDate = new Date(certificate.expirationDate);
                                                                        const currentDate = new Date();
                                                                        const timeDifference = expiryDate - currentDate;
                                                                        const remainingDays = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));
                                                                        if (remainingDays > 0 && remainingDays <= 14) {
                                                                            return (
                                                                                <div style={{ display: "flex", alignItems: "center" }}>
                                                                                    <span
                                                                                        className="smallText"
                                                                                        style={{
                                                                                            color: "#F44336",
                                                                                            fontWeight: "390",
                                                                                            marginRight: "10px",
                                                                                        }}
                                                                                    >
                                                                                        Your certificate will expire in {remainingDays} day{remainingDays > 1 ? "s" : ""}.
                                                                                    </span>
                                                                                    <MdDelete
                                                                                        style={{
                                                                                            color: "#A4A4A4",
                                                                                            fontSize: "18px",
                                                                                            cursor: "pointer",
                                                                                        }}
                                                                                        onClick={() =>
                                                                                            handleDeleteCertificate(
                                                                                                certificate._id,
                                                                                                certificate.key,
                                                                                                certificate.url,
                                                                                                section.title === "Medical Certifications"
                                                                                                    ? "medicaldocuments"
                                                                                                    : "provisionaldocuments"
                                                                                            )
                                                                                        }
                                                                                    />
                                                                                </div>
                                                                            );
                                                                        }
                                                                    }
                                                                    return null;
                                                                })()}


                                                            </div>
                                                        ) : section.title === "Provisional Certificates" ? (
                                                            <div className="flexAutoCol pdngRSM">
                                                                <span className="smallText">Degree: {certificate.degree}</span>
                                                                <span className="smallText">Year of Passing: {certificate.yearOfPassing}</span>
                                                                <span className="smallText">Specialist: {certificate.speciality}</span>
                                                            </div>
                                                        ) : null}
                                                        {certificate.comment && certificate.status !== "approved" && (
                                                            <div className="CommentSec">
                                                                <div className="flexMinWidthRow pdngLSM justfiyEnd alignEnd">
                                                                    <div style={{ display: "flex" }}>
                                                                        <span
                                                                            style={{
                                                                                display: "flex",
                                                                                alignItems: "flex-start",
                                                                                padding: " 4px 4px 0 0",
                                                                            }}
                                                                        >
                                                                            <BiCommentDetail style={{ color: "#C4C4C4" }} />
                                                                        </span>
                                                                        <span
                                                                            className="smallText ellipseMaxLen2"
                                                                            style={{ color: "#C4C4C4" }}
                                                                        >
                                                                            {" "}
                                                                            {certificate.comment}{" "}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                                <div>
                                                    {certificate.comment && certificate.status !== "approved" && (
                                                        <div className="SmallDevice">
                                                            <div className="flexMinWidthRow">
                                                                <div style={{ display: "flex" }}>
                                                                    <span
                                                                        style={{
                                                                            display: "flex",
                                                                            alignItems: "flex-start",
                                                                            padding: " 4px 4px 0 0",
                                                                        }}
                                                                    >
                                                                        <BiCommentDetail style={{ color: "#C4C4C4" }} />
                                                                    </span>
                                                                    <span className="smallText ellipseMaxLen2" style={{ color: "#C4C4C4" }}>
                                                                        {" "}
                                                                        {certificate.comment}{" "}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            ))}
                        </div> */}
                    </div>
                </div>
            </div>
            {openDialog && (
                <Dialog open={openDialog} onClose={handleCloseDialog} fullWidth={true} maxWidth="md">
                    <DialogContent>
                        <Tabs
                            value={value}
                            indicatorColor="primary"
                            textColor="primary"
                            onChange={handleTabChange}
                            aria-label="Add Certificate Tabs"
                        >
                            <Tab label="Medical Certificate" style={{ textTransform: "none" }} />
                            <Tab label="Provisional Certificate" style={{ textTransform: "none" }} />
                        </Tabs>
                        {value === 0 && (
                            <div>
                                <MedicalCertificate
                                    handleCloseDialog={handleCloseDialog}
                                    handleSaveDialog={handleSaveDialog}
                                    medicaldata={medicaldata}
                                    userId={payload.userId}
                                    holdUploadBody={holdUploadBody}
                                    setHoldUploadBody={setHoldUploadBody}
                                    deleteOnlineOrOfflineFile={deleteOnlineOrOfflineFile}
                                    formData={formData}
                                    setFormData={setFormData}
                                    minDate={minDate}
                                />
                            </div>
                        )}
                        {value === 1 && (
                            <div>
                                <ProvisionalCertificate
                                    handleCloseDialog={handleCloseDialog}
                                    handleSaveDialog={handleSaveDialog}
                                    clinic={payload.clinicId}
                                    provisionaldata={provisionaldata}
                                    userId={payload.userId}
                                    departments={departments}
                                    degrees={degrees}
                                    specializations={specializations}
                                    setSpecializations={setSpecializations}
                                    department={department}
                                    setDepartment={setDepartment}
                                    formData={provisionalFormData}
                                    setFormData={setProvisionalFormData}
                                />
                            </div>
                        )}
                    </DialogContent>
                </Dialog>
            )}

            {uploadView && (
                <CertificateFileView
                    data={uploadView}
                    handleClose={handleCloseFile}
                />
            )}

            {editProfile && (
                <EditDoctorProfile
                    editProfile={editProfile}
                    errorMsg={errorMsg}
                    error={error}
                    handleChange={handleChange}
                    handleUpdateDoctor={handleUpdateDoctor}
                    handleEditProfle={handleEditProfle}
                    data={editedDoctor}
                    handlePhoneChange={handlePhoneChange}
                    handleAlternatePhoneChange={handleAlternatePhoneChange}
                />
            )}
        </div>
    ) : (
        ""
    );
};

export default DoctorProfile;
